<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="notificationData"
      :options.sync="pagination"
      :server-items-length="totalMess"
      class="elevation-1"
      :loading="loading"
      :search="search"
      :footer-props="{ 'items-per-page-options': [10, 20, 50, 100, 200] }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search Product"
            single-line
            hide-details
            class="shrink mx-4"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <template>
            <v-btn
              text
              x-small
              @click="seenAllMess"
              v-if="unSeenMess > 0"
              color="blue darken-2"
              ><v-icon style="margin-right: 5px"
                >mdi-checkbox-marked-circle</v-icon
              >
              Mark all read</v-btn
            >
            <v-btn text x-small v-else disabled
              ><v-icon style="margin-right: 5px"
                >mdi-checkbox-marked-circle</v-icon
              >
              Mark all read</v-btn
            >
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.message="{ item }">
        <v-icon v-if="!item.have_seen" color="blue darken-2" small>
          mdi-circle
        </v-icon>
        {{ item.message }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
import moment from "moment-timezone";
import axios from "axios";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  Amplify,

  name: "user_mess",

  data() {
    return {
      notificationData: [],
      totalMess: 0,
      unSeenMess: 0,
      search: "",
      loading: false,

      headers: [
        {
          text: "Message",
          align: "start",
          value: "message",
        },
        { text: "Create Date", value: "created_date" },
      ],

      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: false,
        groupDesc: false,
        multiSort: false,
        mustSort: false,
      },
    };
  },

  watch: {
    pagination: {
      handler() {
        this.loadNotification();
      },
      deep: true,
    },
    search() {
      this.loadNotification();
    },
  },

  methods: {
    getParams() {
      let queryParams = {
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
        sortBy: this.pagination.sortBy[0],
        sortDesc: this.pagination.sortDesc[0],
      };

      if (this.search != "") {
        queryParams["message"] = this.search;
      }

      return queryParams;
    },

    async loadNotification() {
      this.loading = true;
      let queryParams = this.getParams();
      console.log("queryParams: ", queryParams);
      var currentSession = await this.$root.$refs.App.currentSession(
        "user-profile-loadNotification"
      );
      if (currentSession.accessToken) {
        await axios
          .get(
            window.domain +
              "users/" +
              currentSession.username +
              "/notifications",
            {
              headers: { Authorization: currentSession.accessToken },
              params: queryParams,
            }
          )
          .then((response) => {
            console.log("loadNotification response: ", response);
            this.notificationData = response.data.data.notifications;
            this.totalMess = response.data.data.total_count;
            this.unSeenMess = response.data.data.unseen_count;
            for (const i of this.notificationData) {
              i.created_date = moment(i.created_date)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MMM/YYYY - HH:mm:ss");
            }
            this.loading = false;
          })
          .catch((err) => console.log(err));
      } else {
        console.log(
          "currentSession user-profile-loadNotification: ",
          currentSession
        );
      }
      console.log("notificationData: ", this.notificationData);
    },

    async seenAllMess() {
      //console.log("Click!!!!!!!!!!!!")
      await this.$root.$refs.App.seenAllMess();
      await this.loadNotification();
    },
  },

  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadNotification();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>